import { render, staticRenderFns } from "./DialogTemplate.vue?vue&type=template&id=6ad627fd"
import script from "./DialogTemplate.vue?vue&type=script&lang=js"
export * from "./DialogTemplate.vue?vue&type=script&lang=js"
import style0 from "./DialogTemplate.vue?vue&type=style&index=0&id=6ad627fd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports